import { useState } from "react"
import Modal from "../Modal"
import Button from "../Button"
import api from "../../services/api"

const ArchivePlanModal = ({ isOpen, onClose, onSuccess, plan }) => {
  const [archiving, setArchiving] = useState(false)
  const [error, setError] = useState(null)

  const handleArchive = async () => {
    if (!plan) return

    setArchiving(true)
    setError(null)

    try {
      await api.archivePlan(plan.token)
      onSuccess()
      onClose()
    } catch (err) {
      console.error('Failed to archive plan:', err)
      setError(err.response?.data?.message || 'Failed to archive plan')
    } finally {
      setArchiving(false)
    }
  }

  if (!plan) return null

  return (
    <Modal isOpen={isOpen} setIsOpen={onClose} width="md:max-w-screen-sm">
      <div>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
            <i className="fa fa-archive text-red-600 text-xl"></i>
          </div>
          <h2 className="text-2xl font-bold text-gray-900">Delete Plan</h2>
        </div>

        <div className="mb-6">
          <p className="text-gray-700 mb-4">
            Are you sure you want to delete <span className="font-semibold">{plan.name || "Untitled Plan"}</span>?
          </p>
          <div className="bg-red-50 border border-red-200 rounded-lg p-3">
            <p className="text-sm text-red-800 font-medium">
              <i className="fa fa-warning mr-2"></i>
              This action cannot be undone.
            </p>
            <p className="text-sm text-red-700 mt-2">
              The plan will be deleted and hidden from all views.
            </p>
          </div>
        </div>

        {error && (
          <div className="mb-4 bg-red-50 border border-red-200 rounded-lg p-3">
            <p className="text-sm text-red-600">{error}</p>
          </div>
        )}

        <div className="flex justify-end gap-3">
          <Button
            type="button"
            variant="secondary-ghost"
            onClick={onClose}
            disabled={archiving}
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleArchive}
            disabled={archiving}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {archiving ? (
              <>
                <i className="fa fa-spinner fa-spin mr-2"></i>
                Deleting...
              </>
            ) : (
              <>
                <i className="fa fa-archive mr-2"></i>
                Delete Plan
              </>
            )}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ArchivePlanModal
